import React from 'react';
import { View } from 'react-native';

import { Container, SiteTitle } from './index';

const PublicMenu = () => {
  return (
    <Container>
      <SiteTitle>
        Keeping.Care
      </SiteTitle>
    </Container>
  );
};

export default PublicMenu;
